/* eslint-disable no-undefined */
import { MESSAGE_STATE_NEW, MESSAGE_STATE_ACCEPT_ANSWER_PROMPT, MESSAGE_STATE_RATE_AMBASSADOR, MESSAGE_STATE_CLOSED, MESSAGE_STATE_SUGGESTED_ANSWER, MESSAGE_STATE_RESOLVED, MESSAGE_STATE_TIMEDOUT, MESSAGE_STATE_FORWARDED, MESSAGE_STATE_REPORTED, MESSAGE_STATE_RERATE_YOUR_EXPERIENCE, MESSAGE_STATE_PENDING_CLOSURE, MESSAGE_CUSTOMER_OPINION_ACCEPT, MESSAGE_CUSTOMER_OPINION_SCORE } from "./CustomerMessageStateConstants";
import { log as logger } from "../../../common/utils/Logging";
import { getLastDialogue } from "../../../common/utils/message-helper/MessageHelper";
/**
 * Calculate the UI state for a given message
 *
 * @param {object} message
 */

export var calculatePublicMessageState = function calculatePublicMessageState(message) {
  var log = logger.getLogger("MessageActions calculatePublicMessageState");

  var _getLastDialogue = getLastDialogue(message),
      lastDialogue = _getLastDialogue.lastDialogue;

  log.debug("last dialogue: ", lastDialogue);
  log.debug({
    message: message
  });

  if (message.state === MESSAGE_STATE_CLOSED) {
    if (message.lifecycleState === MESSAGE_STATE_FORWARDED) {
      return {
        footerState: MESSAGE_STATE_FORWARDED
      };
    } else if (message.lifecycleState === MESSAGE_STATE_RESOLVED) {
      return {
        footerState: MESSAGE_STATE_CLOSED
      };
    } else if (message.lifecycleState === MESSAGE_STATE_TIMEDOUT) {
      return {
        footerState: MESSAGE_STATE_TIMEDOUT
      };
    }
  } else {
    if (message.reportedAt || message.reportedNote || message.reportedReason) {
      return {
        footerState: MESSAGE_STATE_REPORTED
      };
    } else if (message.custResolved) {
      return {
        footerState: MESSAGE_STATE_CLOSED
      };
    } else if (message.accepted) {
      var resolvedThreshold = message.custScoreScheme.resolvedThreshold,
          customerScore = message.customerScore,
          acceptedDate = message.acceptedDate,
          lastExpertDialogueDate = message.lastExpertDialogueDate;

      if (customerScore) {
        if (customerScore >= resolvedThreshold) {
          return {
            footerState: MESSAGE_STATE_CLOSED
          };
        }
      }

      if (lastExpertDialogueDate > acceptedDate) {
        return {
          footerState: MESSAGE_STATE_RERATE_YOUR_EXPERIENCE
        };
      }

      return {
        footerState: MESSAGE_STATE_PENDING_CLOSURE
      };
    } else if (lastDialogue.type === "suggestedAnswer") {
      return {
        footerState: MESSAGE_STATE_SUGGESTED_ANSWER
      };
    } else if (message.custConfirmation) {
      return {
        footerState: MESSAGE_STATE_ACCEPT_ANSWER_PROMPT
      };
    } else if (message.lifecycleState === MESSAGE_STATE_RESOLVED && message.accepted === undefined) {
      return {
        footerState: MESSAGE_STATE_ACCEPT_ANSWER_PROMPT
      };
    } else if (message.availableToCustomer) {
      switch (message.custOpinionUIControl) {
        case "score":
          {
            if (message.customerScore) {
              return {
                footerState: MESSAGE_STATE_RATE_AMBASSADOR
              };
            } else {
              return {
                footerState: MESSAGE_CUSTOMER_OPINION_SCORE
              };
            }
          }

        case "accept":
          {
            return {
              footerState: MESSAGE_CUSTOMER_OPINION_ACCEPT
            };
          }

        default:
          {
            return {
              footerState: MESSAGE_STATE_NEW
            };
          }
      }
    }
  }

  return {
    footerState: MESSAGE_STATE_NEW
  };
};